<template>
  <li
    class="nav-item dropdown"
    v-if="$configuration.i18nEnabled"
    :class="{ show }"
    v-click-outside="hide"
    @keydown.esc="hide"
  >
    <a
      class="nav-link dropdown-toggle pr-0"
      href="#"
      @click.prevent="toggle"
      role="button"
      aria-haspopup="true"
      :aria-expanded="show"
      id="languages-dropdown"
      data-toggle="dropdown"
      data-testid="languages-dropdown"
    >
      <font-awesome-icon icon="earth-americas" />
      {{ $t('language') }}
    </a>
    <div class="dropdown-menu" role="menu" :class="{ show }" aria-labelledby="languages-dropdown">
      <a
        class="dropdown-item"
        v-for="locale in activeLocales"
        :key="locale.code"
        href="#"
        :data-testid="`language-${locale.code}`"
        @click.prevent="onSwitchLocale(locale)"
      >
        {{ locale.name }}
      </a>
    </div>
  </li>
</template>

<script>
import vClickOutside from 'click-outside-vue3';
import LanguagesMixin from '../../modules/platform/mixins/LanguagesMixin';

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      show: false,
    };
  },
  /**
   * mixin for Locales and switchLocale
   */
  mixins: [LanguagesMixin],
  methods: {
    toggle() {
      this.show = !this.show;
    },
    hide() {
      this.show = false;
    },
    onSwitchLocale(locale) {
      this.hide();
      this.switchLocale(locale);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-link {
  display: block;
  padding: 0.25rem 0.875rem;
}
</style>
